import DropdownNew from '../../common/dropdownNew';
import { Heading } from '../../common/heading';
import styles from './whyNfo.scss';

const whatContent = (
  <div className="sm:lil-pt-2 sm:lil-pb-12">
    <p className="lil-text-base">
      A New Fund Offer (NFO) refers to the introductory offer of a scheme by an
      AMC. An new fund offer is raised when a fund is launched, which helps the
      firm raise capital for purchasing securities.
    </p>
    <br />
    <p className="lil-text-base">
      An investor can subscribe to an NFO only within a limited time period;
      hence, NFOs are functional on a first-come-first serve basis.
    </p>
  </div>
);
const whyContent = (
  <div>
    <ul
      className={`${styles['customList']} sm:lil-pl-4 sm:lil-pt-2 sm:lil-pb-12`}
    >
      <li className="lil-text-font-200 lil-mb-4 lil-font-medium lil-mb-4 lil-text-base lil-text-font-200">
        Significant difference in the NAV of NFO and Normal fund can help users
        to generate more profits
      </li>
      <li className="lil-text-font-200 lil-font-medium lil-mb-4 lil-text-base lil-text-font-200">
        Users can invest in innovative mutual funds schemes launched by the AMC,
        early on. for e.g some schemes invest in recently launched/listed stocks
        and IPOs.
      </li>
    </ul>
  </div>
);
export const WhyNfo = ({ headerClass }) => (
  <div className="lil-pt-12 sm:lil-pt-0">
    <Heading title="About new fund offers (NFO)" titleClass={headerClass} />
    <div className="lil-flex lil-pt-12 lil-items-start sm:lil-pt-6 sm:lil-flex-col">
      <div className="lil-w-1/2 lil-pr-10 sm:lil-pr-0 sm:lil-w-full sm:lil-hidden">
        <h6 className="lil-mb-6">What is a new fund offer or NFO?</h6>
        {whatContent}
      </div>
      <div className="sm:lil-w-full lg:lil-hidden md:lil-hidden xl:lil-hidden">
        <DropdownNew
          heading="About new fund offers (NFO)"
          content={whatContent}
        />
      </div>

      <div className="lil-w-1/2 lil-pl-6 sm:lil-mt-12 sm:lil-pl-0 sm:lil-w-full sm:lil-hidden">
        <h6 className="lil-mb-6">Why should an investor invest in an NFO?</h6>
        {whyContent}
      </div>
      <div className="sm:lil-w-full lg:lil-hidden md:lil-hidden xl:lil-hidden">
        <DropdownNew
          heading="About new fund offers (NFO)"
          content={whyContent}
        />
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/nfoPage/whyNfo/whyNfo.tsx